import { type RootState } from '@verantos-dev/core-annotation-tool';

import { DATA_IMPORT_MODES } from '../constants';
import type { AgentConcept, AgentSection, AnnotationAgentState } from './createProjectSlice';

// Stable empty array reference to avoid unnecessary re-renders

// TODO: cleanup with cp_annotation_createproject_agent ff
const EMPTY_AGENT_CONCEPTS: Record<string, AgentConcept> = {};
const EMPTY_AGENT_SECTIONS: AgentSection[] = [];
const EMPTY_HUMAN_SHARE_PERCENTAGES: Record<string, string> = {};
const EMPTY_ANNOTATION_AGENT: AnnotationAgentState = {
  enabled: false,
  modelId: null,
  concepts: EMPTY_AGENT_CONCEPTS,
  nextSequence: 1,
  sections: EMPTY_AGENT_SECTIONS,
};

export const selectActiveStep = (state: RootState) => state.createProject?.activeStep ?? 0;

export const selectConditionArea = (state: RootState) => state.createProject?.conditionArea ?? null;
export const selectHealthSystem = (state: RootState) => state.createProject?.healthSystem ?? null;
export const selectProjectName = (state: RootState) => state.createProject?.projectName ?? '';
export const selectAddedConcepts = (state: RootState) => state.createProject?.addedConcepts ?? [];
export const selectWorkflowId = (state: RootState) => state.createProject?.workflowId ?? null;
export const selectSelectedAnnotators = (state: RootState) =>
  state.createProject?.selectedAnnotators ?? [];
export const selectSelectedSupervisors = (state: RootState) =>
  state.createProject?.selectedSupervisors ?? [];
export const selectDefaultAllocationMode = (state: RootState) =>
  state.createProject?.defaultAllocationMode ?? true;
export const selectUploadedNotesParquetFileName = (state: RootState) =>
  state.createProject?.uploadedNotesParquetFileName ?? null;
export const selectUploadedPersonParquetFileName = (state: RootState) =>
  state.createProject?.uploadedPersonParquetFileName ?? null;
export const selectUploadedVisitParquetFileName = (state: RootState) =>
  state.createProject?.uploadedVisitParquetFileName ?? null;
export const selectNotesS3FilePath = (state: RootState) =>
  state.createProject?.notesS3FilePath ?? null;
export const selectPersonS3FilePath = (state: RootState) =>
  state.createProject?.personS3FilePath ?? null;
export const selectVisitS3FilePath = (state: RootState) =>
  state.createProject?.visitS3FilePath ?? null;
export const selectUploadedDatasplittingJSONFileName = (state: RootState) =>
  state.createProject?.uploadedDatasplittingJSONFileName ?? null;
export const selectDatasplitJsonS3FilePath = (state: RootState) =>
  state.createProject?.datasplitJsonS3FilePath ?? null;
export const selectDatasetImportMode = (state: RootState) =>
  state.createProject?.datasetImportMode ?? DATA_IMPORT_MODES[0];
export const selectDatasplitImportMode = (state: RootState) =>
  state.createProject?.datasplitImportMode ?? DATA_IMPORT_MODES[0];

// TODO: cleanup with cp_annotation_createproject_agent ff
export const selectIsAgentStepEnabled = (state: RootState) =>
  state.createProject?.isAgentStepEnabled ?? null;
export const selectAnnotationAgentEnabled = (state: RootState) =>
  state.createProject?.annotationAgent.enabled ?? false;
export const selectAnnotationAgentModelId = (state: RootState) =>
  state.createProject?.annotationAgent.modelId ?? null;
export const selectAnnotationAgentConcepts = (state: RootState) =>
  state.createProject?.annotationAgent.concepts ?? EMPTY_AGENT_CONCEPTS;
export const selectAnnotationAgentNextSequence = (state: RootState) =>
  state.createProject?.annotationAgent.nextSequence ?? 1;
export const selectAnnotationAgentSections = (state: RootState) =>
  state.createProject?.annotationAgent.sections ?? EMPTY_AGENT_SECTIONS;
export const selectAnnotationAgent = (state: RootState) =>
  state.createProject?.annotationAgent ?? EMPTY_ANNOTATION_AGENT;
export const selectHumanSharePercentages = (state: RootState) =>
  state.createProject?.humanSharePercentages ?? EMPTY_HUMAN_SHARE_PERCENTAGES;
